import { Layout } from 'antd';
import * as React from 'react';

import { Header } from '../components/Header';
import { MainLayoutHeader } from '../components/MainLayoutHeader';
import routes, { getMenuItems } from '../pages/routes';
import { useAuthStore } from '../stores';

const MENU_ITEMS = getMenuItems(routes.private);

export interface PrivateLayoutProps {
  children: React.ReactNode;
}

export function PrivateLayout({ children }: PrivateLayoutProps) {
  const logout = useAuthStore(({ logout }) => logout);

  return (
    <Layout>
      <MainLayoutHeader>
        <Header items={MENU_ITEMS} onLogout={logout} />
      </MainLayoutHeader>
      <Layout.Content className="contentWrapper">{children}</Layout.Content>
    </Layout>
  );
}
